import Reflux from 'reflux';

let ExportFormActions = Reflux.createActions({
  updateField: {},
  submit: {},
  clear: {},
  populate: {},
  setCurrentlyOpenPanel: {},
  moveColumnUp: {},
  moveColumnDown: {},
  toggleColumn: {},
  togglePrivateNotesPopulation: {},
  toggleTitleRows: {},
});

export default ExportFormActions;
